export const getShopifyAdminUrl = (selectedDomain: string) => {
    const shopName = selectedDomain.replace(".myshopify.com", "");
    return `https://admin.shopify.com/store/${shopName}/`;
}